/**
 * Generic event emitter protocol
 */
export interface IEventEmitter<T> {
  on(handler: { (data?: T): void }): void;
  off(handler: { (data?: T): void }): void;
}

/**
 * Generic event emitter class
 *
 * Can be used to pass data between classes and files.
 * Currently used in the `ConversationRepository` to pass the `subscription event data` back to a `vue component`.
 */
export class EventEmitter<T> implements IEventEmitter<T> {
  private handlers: { (data?: T): void }[] = [];

  public on(handler: { (data?: T): void }): void {
    this.handlers.push(handler);
  }

  public off(handler: { (data?: T): void }): void {
    this.handlers = this.handlers.filter((h) => h !== handler);
  }

  public trigger(data?: T) {
    this.handlers.slice(0).forEach((h) => h(data));
  }

  public expose(): IEventEmitter<T> {
    return this;
  }
}
